import { trackEvent } from "@faire/web/common/trackEvent";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { Suspense } from "react";
import styled from "styled-components";

import { LazySearchProductsRelatedSearchSection } from "@faire/retailer/components/SearchProducts/SearchProductsRelatedSearchSection";
import { discoverSearch } from "@faire/retailer/lib/seoPaths";

export const RelatedSearchList: React.FC<{
  productRelatedSearches?: string[];
}> = ({ productRelatedSearches }) => {
  return (
    <WhenVisibilityIsImminent forceRender={isPrerender()}>
      {productRelatedSearches?.length ? (
        <Suspense fallback={null}>
          <StyledLazySearchProductsRelatedSearchSection
            relatedSearchTerms={productRelatedSearches ?? []}
            onSearchTermClick={(searchTerm: string) => {
              trackEvent(
                `/click/product-page-carousel/related-searches/${searchTerm}`
              );
            }}
            generateSearchTermUrl={discoverSearch}
            leftAlign={true}
          />
        </Suspense>
      ) : null}
    </WhenVisibilityIsImminent>
  );
};
const StyledLazySearchProductsRelatedSearchSection = styled(
  LazySearchProductsRelatedSearchSection
)`
  padding: ${getSpacing("3x", "2x")};

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("5x", "6x")};
  }
`;

LazySearchProductsRelatedSearchSection.displayName =
  "LazySearchProductsRelatedSearchSection";
